import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDailySessionAnalytics } from '../../../../slices/veloxity/adminAnalytics/getDailySessionAnalyticsSlice';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Select from 'react-select';
import ReactApexChart from "react-apexcharts";

const SessionDataAnalytics = ({ licenseKey }) => {
    const dispatch = useDispatch();
    const dailySessionAnalytics = useSelector((state) => state.dailySessionAnalytics.data);

    const [selectedDuration, setSelectedDuration] = useState({ value: "Under 1 minute", label: "Under 1 minute" });
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        if (licenseKey) {
            dispatch(fetchDailySessionAnalytics(licenseKey));
        }
    }, [dispatch, licenseKey]);

    useEffect(() => {
        if (selectedDuration && dailySessionAnalytics && dailySessionAnalytics[selectedDuration.value]) {
            const selectedData = dailySessionAnalytics[selectedDuration.value];

            const avgDurationData = selectedData.map(item => ({
                x: item.date,
                y: parseFloat(item.avgDuration.replace("m", "")),
            }));

            const totalDevicesData = selectedData.map(item => ({
                x: item.date,
                y: item.totalDevice,
            }));

            const distinctDevicesData = selectedData.map(item => ({
                x: item.date,
                y: item.totalDistinctDevice,
            }));

            setChartData([
                { name: "Avg Duration (minutes)", type: "line", data: avgDurationData },
                { name: "Total Devices", type: "bar", data: totalDevicesData },
                { name: "Total Distinct Devices", type: "bar", data: distinctDevicesData }
            ]);
        } else {
            setChartData([]); // Veri olmadığında boş grafik göster
        }
    }, [selectedDuration, dailySessionAnalytics]);

    const durationOptions = [
        { value: "Under 1 minute", label: "Under 1 minute" },
        { value: "1-2 minutes", label: "1-2 minutes" },
        { value: "2-3 minutes", label: "2-3 minutes" },
        { value: "3-5 minutes", label: "3-5 minutes" },
        { value: "Above 5 minutes", label: "Above 5 minutes" }
    ];

    const maxDeviceCount = chartData.length > 1 && chartData[1]?.data && chartData[2]?.data
        ? Math.max(
            ...chartData[1].data.map(item => item.y || 0),
            ...chartData[2].data.map(item => item.y || 0)
        )
        : 100;

    const chartOptions = {
        chart: {
            height: 350,
            type: 'line',
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                columnWidth: '30%',
                dataLabels: { position: 'top' }
            }
        },
        stroke: {
            width: [2, 0, 0],
            curve: "smooth"
        },
        xaxis: {
            type: 'category',
            title: { text: 'Date' }
        },
        yaxis: [
            {
                title: { text: 'Avg Duration (minutes)' },
                labels: { formatter: val => `${val.toFixed(2)}m` },
                min: 0,
                forceNiceScale: true,
            },
            {
                opposite: true,
                title: { text: 'Device Count' },
                min: 0,
                max: maxDeviceCount,
                labels: {
                    formatter: val => Math.round(val).toLocaleString()  
                }
            }
        ],
        tooltip: {
            shared: true,
            intersect: false,
            y: [
                {
                    formatter: (val) => val ? `${val.toFixed(2)}m` : "N/A"
                },
                {
                    formatter: (val) => val ? `${Math.round(val).toLocaleString()}` : "N/A"
                },
                {
                    formatter: (val) => val ? `${Math.round(val).toLocaleString()}` : "N/A"
                }
            ],
        },
        legend: { position: "top" }
    };

    return (
        <Card>
            <CardHeader className="align-items-center d-flex" style={{ padding: '0 15px' }}>
                <h4 className="card-title mb-0 flex-grow-1">Session Data Analytics</h4>
                <div className="flex-shrink-0">
                    <Select
                        options={durationOptions}
                        value={selectedDuration}
                        onChange={setSelectedDuration}
                        placeholder="Select Duration Range"
                        className="mb-4"
                    />
                </div>
            </CardHeader>
            <CardBody >
    {chartData.length > 0 ? (
        <ReactApexChart
            options={chartOptions}
            series={chartData}
            type="line"
            height={350}
        />
    ) : (
        <p>No data available for the selected duration.</p>
    )}
</CardBody>
        </Card>
    );
};

export default SessionDataAnalytics;
